// eslint-disable-next-line no-restricted-imports
import { State } from 'modules';
// eslint-disable-next-line no-restricted-imports
import { UpNextViewModel } from 'types';

import { getBoardById } from './boards';
import { getListById } from './lists';
import { isReplyOpen } from './super-home';
import { getTeamById } from './teams';

export const getUpNext = (state: State): UpNextViewModel[] => {
  return state.models.upNext.map((upNext) => {
    const boardId = upNext.data.card.idBoard;
    const board = (boardId && getBoardById(state, boardId)) || null;
    const listId = upNext.data.card.idList;
    const list = listId ? getListById(state, listId)! : null;
    const teamId = board && board.idTeam;
    const team = teamId ? getTeamById(state, teamId)! : null;

    return {
      ...upNext,
      replyOpen: isReplyOpen(state, `reply-card-${upNext.id}`),
      team,
      board,
      list,
    };
  });
};



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/up-next.ts